<style>
    .inputDoc {
        border: 0;
        padding-left: 3px;
        padding-right: 3px;
        border-bottom: 2px dotted gray;
    }

    .inputNone {
        border: 0;
        padding-left: 3px;
        padding-right: 3px;
    }

    .input-square {
        border: 1px solid gray;
        width: 16px;
        height: 16px;
        margin: 0;
        text-align: center;
    }

    .inputDate {
        border: 0;
        padding-left: 3px;
        padding-right: 3px;
        border-bottom: 2px dotted gray;
        width: 30px;
    }

    .inputYear {
        border: 0;
        padding-left: 3px;
        padding-right: 3px;
        border-bottom: 2px dotted gray;
        width: 50px;
    }

    .inputDocTb {
        border: 0;
        padding-bottom: 5px;
    }

    .doc-wrapper {
        width: 210mm;
        min-height: 297mm;
        padding: 20mm 10mm 20mm 20mm;
        font-family: Roboto;
        font-size: 16px;
        color: #000;
        background-color: #fff;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
    }

    .lblInputDoc {
        margin-bottom: 0;
        padding-left: 3px;
        padding-right: 3px;
    }

    .page-break-before {
        margin: 25.4mm 0 25.4mm -25.4mm;
        min-height: 5mm;
        min-width: 210mm;
        background-color: #efedec;
    }

    .view-document-dialog td.fitwidth {
        display: contents;
    }

    input.full-width {
        width: 100%;
    }

    input.bold {
        font-weight: bold !important;
    }

    .view-document-dialog input[type="checkbox"],
    .view-document-dialog input[type="radio"] {
        width: 15px;
        height: 15px;
        margin-right: 10px;
        display: inline-block !important;
    }

    textarea {
        width: 100%;
    }

    .template-mapping-input-bold-weight {
        font-weight: bold;
    }

    .signStatusImage {
        width: 100px;
    }

    .view-document-dialog .tableActionButtonRow {
        display: none;
    }

    .view-document-dialog .displayTableTemplate {
        display: none;
    }

    .view-document-dialog .display-data-field {
        display: inline;
        white-space: -moz-pre-wrap !important;
        /* Mozilla, since 1999 */
        white-space: -webkit-pre-wrap;
        /*Chrome & Safari */
        white-space: -pre-wrap;
        /* Opera 4-6 */
        white-space: -o-pre-wrap;
        /* Opera 7 */
        white-space: pre-wrap;
        /* CSS3 */
        word-wrap: break-word;
        /* Internet Explorer 5.5+ */
        white-space: normal;
    }

    .lbl-square {
        border: 1px solid gray;
        width: 16px;
        height: 16px;
        padding: 0 4px;
        margin-right: 3px;
        text-align: center;
    }

    .view-document-dialog .contract-data-field {
        display: none !important;
    }

    /*Styles for table in .table-div-pdf*/
    .view-document-dialog .table-div-pdf table {
        display: block;
    }

    .view-document-dialog .table-div-pdf table {
        margin: 0 auto;
        width: 100%;
        border-collapse: collapse;
        border: 1px solid black;
    }

    .view-document-dialog .table-div-pdf table thead {
        background: #bfbfbf;
    }

    .view-document-dialog .table-div-pdf table thead td {
        text-align: center;
    }

    .view-document-dialog .table-div-pdf table thead {
        background: #bfbfbf;
    }

    .view-document-dialog .table-div-pdf table tr {
        height: 16.05pt;
        padding: 0in 5.4pt 0in 5.4pt;
    }

    .view-document-dialog .table-div-pdf table td,
    .view-document-dialog .table-div-pdf table th {
        border: solid 1px black;
        margin: 0;
        padding: 5px;
        line-height: 27px;
        /* word-break: break-all; */
    }

    .view-document-dialog .table-div-pdf table td.break-all {
        word-break: break-all;
        text-align: right;
    }

    .box-tab {
        overflow-x: auto;
        overflow-y: hidden;
    }

    .box-tab::-webkit-scrollbar {
        height: 5px;
        background-color: #f5f5f5;
    }

    .box-tab::-webkit-scrollbar-thumb {
        background-color: #a6a6a6;
    }

    .box-tab::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
        background-color: #f5f5f5;
    }

    .tab-reference {
        color: black;
        border-radius: 5px 5px 0 0;
        background-color: #f2f2f2;
        cursor: pointer;
        min-width: 40px;
        position: relative;
    }

    .tab-reference .name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        line-height: 28px;
        font-size: 12px;
    }

    .tab-reference.active {
        background-color: #a6a6a6;
        color: white;
    }

    .tab-reference.left {
        border-bottom-right-radius: 5px;
    }

    .tab-reference.right {
        border-bottom-left-radius: 5px;
    }

    .tab-reference.border-right::after {
        content: '';
        position: absolute;
        width: 1px;
        height: 30px;
        background: #a6a6a6;
        right: -1px;
        top: 50%;
        transform: translate(0, -50%);
    }

    .btn-close {
        display: flex !important;
        align-items: center !important;
        color: #f40033;
        border: 1px solid rgba(0, 0, 0, 0.12) !important;
        border-radius: 4px !important;
        box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 20%), 0px 0px 0px 0px rgb(0 0 0 / 14%), 0px 0px 0px 0px rgb(0 0 0 / 12%) !important;
        cursor: pointer;
        padding: 5px 28px !important;
        background-color: white !important;
    }

    .btn-close:hover {
        background-color: #b5b4b4 !important;
    }
</style>

<h2 mat-dialog-title>
    {{ "title.papers_view" | translate }}
    <button type="button" class="close" [mat-dialog-close]="true" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</h2>
<mat-divider></mat-divider>
<mat-dialog-content #focus tabindex="-1">
    <div class="d-flex" id="box-center" style="width: 100%">
        <div class="d-flex" id="box-center" style="width: 100%">
            <div style="width: 100%; position: relative; height: 44px;">
                <div class="d-flex box-tab" style="
          position: absolute;
          width: 100%;
          top: 0;
          left: 0;
          height: 44px;
          margin-top: 0.5rem;
        ">
                    <div class="px-2 py-2 tab-reference active w-100" [matTooltip]="fileName">
                        <div class="name">
                            {{ fileName }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="background-color: #efedec; padding: 20px">
        <div style="
          max-width: 832px;
          margin: 0 auto;
          background-color: #fff;
          padding: 20px;
        ">
            <ngx-extended-pdf-viewer class="pdf-viewer" [base64Src]="filePathBase64" useBrowserLocale="true"
                [showDownloadButton]="false" [showRotateButton]="false" [showOpenFileButton]="false"
                [showBookmarkButton]="false" [showPropertiesButton]="false" [showUnverifiedSignatures]="true"
                [sidebarVisible]="true" [enablePrint]="false" style="display: block"
                [showSecondaryToolbarButton]="false" [textLayer]="true" useBrowserLocale="true" [showToolbar]="false"
                [theme]="'dark'" [language]="language" height="calc(65vh - 124px)" style="display: block">
            </ngx-extended-pdf-viewer>
        </div>
    </div>
</mat-dialog-content>

<mat-divider></mat-divider>
<mat-dialog-actions align="center" class="mt-2">
    <button class="mr-3 btn-close" type="button" [mat-dialog-close]="true" cdkFocusInitial>
        <mat-icon class="mr-0 d-flex align-items-center">cancel</mat-icon>{{ "view_pdf.buttons.close" | translate }}
    </button>
</mat-dialog-actions>